var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chartOptions)?_c('Chart',{staticClass:"h-100 mr-4",attrs:{"options":_vm.chartOptions}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }